import { useQuery } from '@tanstack/react-query'
import { reactions } from '@opallabs/api/v2'
import { queryKeys } from './queryKeys'

export const useGetReactions = () =>
  useQuery({
    queryKey: queryKeys.reactions,
    queryFn: () => reactions.read(),
    select: (response) =>
      response.data
        .map((reaction) => ({
          id: reaction.id,
          name: reaction.attributes.display_name,
          emoji: reaction.attributes.emoji,
        }))
        .sort((a, b) => (a.name > b.name ? -1 : 1)),
  })
